export default "__VITE_ASSET__Dt_28uwI__"